import { APP_INITIALIZER } from '@angular/core';
import { ManageProfileTabsService } from '@volo/abp.ng.account/public/config';
import { UsuariosAcessosComponent } from './usuarios-acessos.component';

export const USUARIOS_ACESSOS_TAB_PROVIDER = {
  provide: APP_INITIALIZER,
  useFactory: configureUsuariosAcessosTab,
  deps: [ManageProfileTabsService],
  multi: true,
};

export function configureUsuariosAcessosTab(tabs: ManageProfileTabsService) {
  return () => {
    tabs.add([
      {
        // A gestão de usuários do tenant mora no Minha conta (decisão do Ronan 14/08), ao lado
        // das outras abas de configuração da casa (Acesso Galileu, Whatsapp). Só quem pode gerir
        // usuários (o admin do tenant) enxerga — o serviço filtra por requiredPolicy igual ao menu.
        name: 'Usuários e Acessos',
        order: 7,
        requiredPolicy: 'AbpIdentity.Users',
        component: UsuariosAcessosComponent,
      },
    ]);
  };
}
